/*
 * Copyright (c) 2022. Revo Digital
 * ---
 * Author: gabriele
 * File: AlignmentControlInput.ts
 * Project: mle-client-n
 * Committed last: 2022/1/25 @ 139
 * ---
 * Description:
 */

import {
  HorizontalAlignment
}                                 from '@revodigital/pamela/lib/configuration/Alignment';
import { ChildControlFieldProps } from './ShapeControlView';
import { ShapeControlWrapper } from './ShapeControlWrapper';
import { AlignmentController } from '../drawing/AlignmentController';

export const AlignmentControlInput = (props: ChildControlFieldProps<HorizontalAlignment> & { enableJustify: boolean }) => {
  return (
    <ShapeControlWrapper label={ props.label } labelInfo={ props.labelInfo }>
      <AlignmentController observableValue={ props.observableValue }
                           setter={ props.setter } title={ '' }
                           enableJustify={ props.enableJustify }/>
    </ShapeControlWrapper>
  );
};